import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import * as FileSaver from 'file-saver';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpEvent } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileServiceService {

  constructor(
    private excelService: ExcelService
  ) { }


  downloadBase64(b64DataTotal, fileName, contentType, sliceSize): Observable<any[]> {

    return Observable.create(observer => {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64DataTotal);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, { type: contentType });
      fileName = fileName.replace(/[<>:"\/\\|?*]+/g, '_');

      if (contentType === 'application/vnd.ms-outlook') {
        fileName = fileName + ".msg";
        FileSaver.saveAs(blob, fileName);
      } else {
        FileSaver.saveAs(blob, fileName);
      }
      console.log("Trying to save as blob");
      var returnObj = {
        success: true
      }

      observer.next(returnObj);
      observer.complete();
    });
  }



  downLoadFile(data: any, type: string, reportName: string) {
    var blob = new Blob([data], { type: type });
    FileSaver.saveAs(blob, reportName);
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      alert("There was an error downloading the file, Error: " + error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
  }


  downloadBase64_old = function (b64DataTotal, fileName, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64DataTotal);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    fileName = fileName.replace(/[<>:"\/\\|?*]+/g, '_');
    FileSaver.saveAs(blob, fileName);
  };


  base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }












  handleMultipartContent(arrayBuffer: ArrayBuffer, contentType: string): Promise<any[]> {
    // Extract boundary from content type

    return new Promise((resolve, reject) => {

      const blobArray: any[] = [];

      const boundary = contentType.split('boundary=')[1];

      var boundary_adj = boundary.replace(/^["']|["']$/g, '');

      const multipartData = this.parseMultipart(arrayBuffer, boundary_adj);

      multipartData.forEach(part => {
        const contentDisposition = part.headers['content-disposition'];
        const fileType = part.headers['content-type'];
        //const filenameMatch = contentDisposition.match(/filename="(.+?)"/);
        const filenameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
        const filename = filenameMatch ? filenameMatch[1] : 'file_' + Date.now();

        //this.saveFile(part.data, filename);

        var blobObject = {
          fileData: part.data,
          fileType: fileType,
          fileName: filename,
        }
        console.log("Adding File Object");
        blobArray.push(blobObject);

      });

      resolve(blobArray);

    })
  }




  private parseMultipart(buffer: ArrayBuffer, boundary: string): any[] {
    // Remove quotes from boundary if present
    const cleanBoundary = boundary.replace(/^["']|["']$/g, '');
    const boundaryString = `--${cleanBoundary}`;
    const endBoundaryString = `${boundaryString}--`;

    // Work with Uint8Array instead of strings for binary safety
    const uint8Array = new Uint8Array(buffer);

    // Convert boundary strings to bytes for binary search
    const boundaryBytes = this.stringToUint8Array(boundaryString + '\r\n');
    const endBoundaryBytes = this.stringToUint8Array(endBoundaryString);

    const parts: any[] = [];
    let currentPos = 0;

    while (currentPos < uint8Array.length) {
      // Find the next boundary
      const boundaryIndex = this.findSubarray(uint8Array, boundaryBytes, currentPos);
      if (boundaryIndex === -1) break;

      // Find the end of headers (double CRLF)
      const headersEndIndex = this.findSubarray(
        uint8Array,
        new Uint8Array([0x0D, 0x0A, 0x0D, 0x0A]), // \r\n\r\n
        boundaryIndex + boundaryBytes.length
      );

      if (headersEndIndex === -1) break;

      // Extract headers as text
      const headersArray = uint8Array.slice(
        boundaryIndex + boundaryBytes.length,
        headersEndIndex
      );
      const headersText = new TextDecoder().decode(headersArray);

      // Parse headers
      const headers: { [key: string]: string } = {};
      headersText.split('\r\n').forEach(line => {
        if (line) {
          const [name, value] = line.split(': ');
          headers[name.toLowerCase()] = value;
        }
      });

      // Find the next boundary to determine content end
      const nextBoundaryIndex = this.findSubarray(
        uint8Array,
        boundaryBytes,
        headersEndIndex + 4
      );

      const contentEnd = nextBoundaryIndex !== -1
        ? nextBoundaryIndex - 2 // account for CRLF before boundary
        : uint8Array.length;

      // Extract the binary content
      const contentArray = uint8Array.slice(
        headersEndIndex + 4, // skip CRLFCRLF
        contentEnd
      );

      parts.push({
        headers,
        data: contentArray.buffer
      });

      currentPos = contentEnd;
    }

    return parts;
  }

  // Helper to find a subarray within a larger array
  private findSubarray(haystack: Uint8Array, needle: Uint8Array, startPos = 0): number {
    for (let i = startPos; i <= haystack.length - needle.length; i++) {
      let found = true;
      for (let j = 0; j < needle.length; j++) {
        if (haystack[i + j] !== needle[j]) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
    return -1;
  }

  // Helper to convert string to Uint8Array
  private stringToUint8Array(str: string): Uint8Array {
    const encoder = new TextEncoder();
    return encoder.encode(str);
  }






  parseMultipart_Old(buffer: ArrayBuffer, boundary: string): any[] {
    // This is a simplified multipart parser - you might need a more robust solution
    const boundaryString = `--${boundary}`;
    const endBoundaryString = `${boundaryString}--`;
    const decoder = new TextDecoder();
    const dataView = new DataView(buffer);

    // Convert ArrayBuffer to string for easier parsing
    const text = decoder.decode(dataView);
    const parts = text.split(boundaryString).slice(1, -1);

    return parts.map(part => {
      const headersEnd = part.indexOf('\r\n\r\n');
      const headersText = part.substring(0, headersEnd);
      const body = part.substring(headersEnd + 4);

      // Parse headers
      const headers: { [key: string]: string } = {};
      headersText.split('\r\n').forEach(line => {
        if (line) {
          const [name, value] = line.split(': ');
          headers[name.toLowerCase()] = value;
        }
      });

      return {
        headers,
        data: this.stringToArrayBuffer(body)
      };
    });
  }


  stringToArrayBuffer(str: string): ArrayBuffer {
    const buffer = new ArrayBuffer(str.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < str.length; i++) {
      view[i] = str.charCodeAt(i);
    }
    return buffer;
  }






}



